module.exports = __webpack_public_path__ + "fonts/c68e9fac-92b0-47be-853c-1a0e92f68c3d.782d8f9.ttf";